import { useContext, useEffect } from "react";

import useAbortableFetch from "use-abortable-fetch";
import { useRequestInit, ForceRerenderContext } from "adviesbox-shared";

export type HdnBerichtSoortType = "AX" | "DA" | "DX" | "KX";
export type UseHdnDataResult = {
  error: null | Error;
  hdnKeuzelijst: { [index: string]: string };
};

export function useHdnData(berichtSoortType: HdnBerichtSoortType, keuzelijst: string): UseHdnDataResult {
  const loadingDone = useContext(ForceRerenderContext);

  const {
    requestInit,
    settings: { hdnKeuzelijstenOrigin }
  } = useRequestInit();
  const url = `${hdnKeuzelijstenOrigin}/${berichtSoortType}/${keuzelijst}`;
  const { error, data, loading } = useAbortableFetch<UseHdnDataResult>(url, requestInit);

  useEffect((): void => {
    if (!loading && !!data && loadingDone) {
      loadingDone();
    }
  }, [loading, data, loadingDone]);

  const listWithLoadingEntry = { "-1": "Laden..." };

  if (typeof data === "string") {
    return { error: new Error("Fout bij het laden van HDN data"), hdnKeuzelijst: {} };
  }

  return { error, hdnKeuzelijst: !data || !data.hdnKeuzelijst ? listWithLoadingEntry : data.hdnKeuzelijst };
}
